module.exports = __webpack_public_path__ + "img/C08TechIndrasGiftRM_ua.975a087b.webp";